import AuctionSchedule from './AuctionSchedule/AuctionSchedule';
import MyFavorites from './MyFavorites/MyFavorites';
import classes from './DashboardContent.module.scss';
import AuctionDash from './AuctionDash/AuctionDash';
import InspectionRequest from './InspectionRequest/InspectionRequest';
import RecentPurchases from './RecentPurchases/RecentPurchases';
import AuthContext from '../../store/auth-context';
import { useContext } from 'react';
const DashboardContent = () => {
    const {userData} = useContext(AuthContext);
    console.log('UserData Dashboard',userData);
    return (
        <div className={classes.DashboardContentBG}>
            <div className={classes.DashboardContent}>
                <div className={classes.DashWidget1}>
                    <AuctionSchedule />
                    <MyFavorites />
                </div>
                <div className={classes.DashWidget2}>
                    <div className={classes.AuctionDiv}>
                        <AuctionDash />
                    </div>
                    <div className={classes.RequestDiv}>
                        <InspectionRequest />
                        <RecentPurchases />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardContent;